import { useState } from 'react';
import { Controller, EffectFade, Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination'
import 'swiper/css/navigation'

export default function ProductsHeader({
  products,
  category,
}: {
  products: Array<any>;
  category: string;
}) {
  const [firstSwiper, setFirstSwiper] = useState(null);
  const [secondSwiper, setSecondSwiper] = useState(null);
  const productFolders = [
    'spirits', 'licors', 'tequila', 'whisky', 'mezcal',
    'beer', 'wine', 'water', 'juice', 'aperitif',
    'groceries', 'food', 'carbo-alcoholic', 'sparkling-no-alcoholic', 'gin'
  ];

  const imageCache: Record<string, any> = {};

  const getProductImage = (category: string, imgName: string) => {
    if (!imgName) return null;
    if (imageCache[imgName]) return imageCache[imgName];

    // Try the category folder first
    const foldersToTry = [category, ...productFolders.filter(f => f !== category)];

    for (const folder of foldersToTry) {
      try {
        const img = require(`../../../assets/products/${folder}/${imgName}`);
        imageCache[imgName] = img;
        return img;
      } catch (e) {
        // Continue to next folder
      }
    }
    console.warn(`Could not load image: ${imgName} in any product folder`);
    return null;
  };

  return (
    <div className="flex flex-col md:flex-row relative mt-[240px] md:mt-0">
      <div className="bg-[#57B9FF] w-full md:left-[16%] md:w-[84%] mt-5 rounded-2xl absolute bluebgProducts"></div>
      <div className="h-[360px] absolute -top-48 md:left-0 md:top-0 md:relative md:h-auto w-full md:w-[30%]">
        <Swiper
          modules={[Controller, Autoplay]}
          onSwiper={(e: any) => setFirstSwiper(e)}
          autoplay={{ delay: 5500, disableOnInteraction: false, }}
          controller={{ control: secondSwiper }}>
          {products.map((info, index) => {
            const imgSrc = getProductImage(category, info.img);
            return (
              <SwiperSlide key={index}>
                <div className="absolute w-[100%] md:top-0 h-full flex items-center justify-center">
                  {imgSrc ? (
                    <img
                      className="object-contain w-full h-full"
                      src={imgSrc}
                      alt={info.name}></img>
                  ) : (
                    <div className="w-[85%] h-[85%] rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 flex flex-col items-center justify-center p-6 text-center shadow-xl">
                      <div className="text-white/20 text-5xl mb-4 font-bold select-none tracking-widest">
                        MDI
                      </div>
                      <span className="text-white/95 text-sm font-semibold tracking-wider uppercase">
                        {info.name}
                      </span>
                      <span className="text-white/50 text-xs mt-2 italic font-light">
                        Premium Selection
                      </span>
                    </div>
                  )}
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>

      <div className="mt-[200px] md:mt-0 px-[5%] md:px-0 md:w-[65%] md:py-10">
        <Swiper
          style={{
            "--swiper-navigation-size": "15px",
          }}
          modules={[Controller, EffectFade, Navigation, Pagination]}
          onSwiper={(e: any) => setSecondSwiper(e)}
          controller={{ control: firstSwiper }}
          effect="fade"
          navigation={true}
          pagination={{ clickable: true }}>
          {products.map((info, index) => (
            <SwiperSlide key={index}>
              <div className="text-white text-center md:text-left pt-12 md:pt-4 pb-16">
                <div className="flex flex-col gap-4 mt-12">
                  <p className="font-bold text-center md:text-left text-3xl">
                    {info.name}
                  </p>
                  <p>{info.description}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
